import React, { useCallback, useEffect, useState } from "react";
import {
  MenuItem,
  Checkbox,
  Stack,
  TextField,
  Typography,
  ListItemText,
  FormGroup,
  FormControlLabel,
} from "@mui/material";

//@ts-ignore
import BpmnModeler from "bpmn-js/lib/Modeler";
//@ts-ignore
import { getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import {
  generateCronExpression,
  parseCronExpression,
  convertNumbersToStrings,
} from "../../../../../../../../utils/DateUtils";
import MinuteRecurrenceGenerator from "../MinuteRecurrenceGenerator";
import HourlyRecurrenceGenerator from "../HourlyRecurrenceGenerator";
import DailyRecurrenceGenerator from "../DailyRecurrenceGenerator";
import { getTranslation } from "common";
import { useTranslations } from "hooks";
import { DAYS, MONTHS } from "common/utilities";

interface TimerDefinitionSettingsTypes {
  timerType: string;
  timeDateValue: Date | null;
  modeler: BpmnModeler;
  element: any;
}

type typeTwoValueInterface = Record<number, boolean>;

const TimerDefinitionSettings = (props: TimerDefinitionSettingsTypes) => {
  const { modeler, element } = props;
  const [typeOfRepeat, setTypeOfRepeat] = useState<string>("");
  const translations = useTranslations();
  // const { sendSnack } = useSnackbar();
  const [dailyRecursCount, setDailyRecursCount] = useState<number>(0);
  const [selectedDaysOfTheWeek, setSelectedDaysOfTheWeek] = useState<
    Record<number, boolean>
  >([]);
  const [selectedMonths, setSelectedMonths] = useState<Array<number>>([]);

  const [selectedMinuteRecurrenceType, setSelectedMinuteRecurrenceType] =
    useState<number>(0);
  const [typeOneMinuteStartsAt, setTypeOneMinuteStartsAt] =
    useState<string>("");
  const [typeOneMinuteInterval, setTypeOneMinuteInterval] =
    useState<string>("");
  const [typeTwoMinuteValue, setTypeTwoMinuteValue] =
    useState<typeTwoValueInterface>({});

  const [selectedHourlyRecurrenceType, setSelectedHourlyRecurrenceType] =
    useState<number>(0);
  const [typeOneHourStartsAt, setTypeOneHourStartsAt] = useState<string>("");
  const [typeOneHourInterval, setTypeOneHourInterval] = useState<string>("");
  const [typeTwoHourValue, setTypeTwoHourValue] =
    useState<typeTwoValueInterface>({});
  // daily

  const [typeTwoDayValue, setTypeTwoDayValue] = useState<typeTwoValueInterface>(
    {}
  );

  useEffect(() => {
    if (
      element.type === "bpmn:StartEvent" ||
      element.type === "bpmn:IntermediateCatchEvent" ||
      element.type === "bpmn:BoundaryEvent"
    ) {
      const bo = getBusinessObject(element);
      const formalExpressionOfCycle =
        bo.eventDefinitions && bo.eventDefinitions.length
          ? bo.eventDefinitions[0]?.timeCycle
          : "";
      if (formalExpressionOfCycle) {
        const valueInIsoFormat = formalExpressionOfCycle.body;
        const parsedCronValues = parseCronExpression(valueInIsoFormat);
        if (parsedCronValues.selectedMonths.length) {
          setTypeOfRepeat("Monthly");
        } else if (
          parsedCronValues.daysInterval ||
          parsedCronValues.selectedDays.length
        ) {
          setTypeOfRepeat("Daily");
        } else if (
          parsedCronValues.selectedDaysOfTheMonth.includes(-1) ||
          (parsedCronValues.daysOfTheMonthInterval &&
            parsedCronValues.startDay) ||
          parsedCronValues.selectedDaysOfTheMonth.length
        ) {
          setTypeOfRepeat("Daily");
        } else if (
          parsedCronValues.selectedHours.includes(-1) ||
          (parsedCronValues.hoursInterval && parsedCronValues.startHour) ||
          parsedCronValues.selectedHours.length
        ) {
          setTypeOfRepeat("Hourly");
        } else if (
          parsedCronValues.selectedMinutes.includes(-1) ||
          (parsedCronValues.minutesInterval && parsedCronValues.startMinute) ||
          parsedCronValues.selectedMinutes.length
        ) {
          setTypeOfRepeat("Minutely");
        }

        setSelectedMonths(parsedCronValues.selectedMonths);
        setDailyRecursCount(
          parsedCronValues.daysInterval ? parsedCronValues.daysInterval : 1
        );

        let selectedDays = parsedCronValues.selectedDays.includes(-1)
          ? []
          : parsedCronValues.selectedDays;
        setSelectedDaysOfTheWeek(
          Object.fromEntries(selectedDays.map((key) => [key, true]))
        );

        //days of the month
        if (parsedCronValues.selectedDaysOfTheMonth) {
          const selectedDaysOfTheMonthObject = convertNumbersToStrings(
            parsedCronValues.selectedDaysOfTheMonth
          ).reduce(
            (daysOfTheMonthObject: Record<string, boolean>, day: string) => {
              daysOfTheMonthObject[day] = true;
              return daysOfTheMonthObject;
            },
            {}
          );

          setTypeTwoDayValue(selectedDaysOfTheMonthObject);
        }

        //hours

        if (parsedCronValues.selectedHours.includes(-1)) {
          setSelectedHourlyRecurrenceType(1);
        } else if (
          parsedCronValues.hoursInterval &&
          parsedCronValues.startHour
        ) {
          setSelectedHourlyRecurrenceType(2);
          setTypeOneHourInterval(
            parsedCronValues.hoursInterval ? parsedCronValues.hoursInterval : ""
          );
          setTypeOneHourStartsAt(
            parsedCronValues.startHour ? parsedCronValues.startHour : ""
          );
        } else if (parsedCronValues.selectedHours.length) {
          setSelectedHourlyRecurrenceType(3);
          const selectedHoursObject = convertNumbersToStrings(
            parsedCronValues.selectedHours
          ).reduce((hourObject: Record<string, boolean>, hour: string) => {
            hourObject[hour] = true;
            return hourObject;
          }, {});

          setTypeTwoHourValue(selectedHoursObject);
        } else {
          setSelectedHourlyRecurrenceType(0);
        }
        //minutes
        if (parsedCronValues.selectedMinutes.includes(-1)) {
          setSelectedMinuteRecurrenceType(1);
        } else if (
          parsedCronValues.minutesInterval &&
          parsedCronValues.startMinute
        ) {
          setSelectedMinuteRecurrenceType(2);
          setTypeOneMinuteInterval(
            parsedCronValues.minutesInterval
              ? parsedCronValues.minutesInterval
              : ""
          );
          setTypeOneMinuteStartsAt(
            parsedCronValues.minutesInterval
              ? parsedCronValues.minutesInterval
              : ""
          );
        } else if (parsedCronValues.selectedMinutes.length) {
          setSelectedMinuteRecurrenceType(3);
          const selectedMinutesObject: typeTwoValueInterface =
            convertNumbersToStrings(parsedCronValues.selectedMinutes).reduce(
              (minuteObject: Record<string, boolean>, minute: string) => {
                minuteObject[minute] = true;
                return minuteObject;
              },
              {}
            );
          setTypeTwoMinuteValue(selectedMinutesObject);
        } else {
          setSelectedMinuteRecurrenceType(0);
        }
      }
    }
    // eslint-disable-next-line
  }, []);

  const onSaveCycleTimerDefenitionSettings = (value: string) => {
    if (value) {
      let moddle: any = modeler.get("moddle");

      const bo = getBusinessObject(element);

      const isFormalExpressionExist = bo.eventDefinitions[0]?.timeCycle;
      if (isFormalExpressionExist) {
        let eventDefinition = bo.eventDefinitions[0];
        eventDefinition.timeCycle.body = value;

        delete eventDefinition["timeDate"];
        delete eventDefinition["timeDuration"];

        modeler.get<any>("modeling").updateProperties(element, {
          eventDefinitions: [eventDefinition],
        });
        // sendSnack({
        //   message: "Model update (n.t)",
        //   type: "success",
        // });
      } else {
        let formalExpression = moddle.create("bpmn:FormalExpression", {
          body: value,
        });

        let eventDefinition = bo.eventDefinitions[0];

        delete eventDefinition["timeDate"];
        delete eventDefinition["timeDuration"];

        eventDefinition["timeCycle"] = formalExpression;

        modeler.get<any>("modeling").updateProperties(element, {
          eventDefinitions: [eventDefinition],
        });
        // sendSnack({
        //   message: "Model update (n.t)",
        //   type: "success",
        // });
      }
    }
  };

  const saveTdsSettings = useCallback(() => {
    let hourObject = {};

    if (selectedHourlyRecurrenceType === 0) {
      hourObject = { selectedHours: [] };
    } else if (selectedHourlyRecurrenceType === 1) {
      hourObject = {
        selectedHours: [-1],
      };
    } else if (selectedHourlyRecurrenceType === 2) {
      hourObject = {
        hoursInterval: typeOneHourInterval,
        startHour: typeOneHourStartsAt,
      };
    } else if (selectedHourlyRecurrenceType === 3) {
      hourObject = {
        selectedHours: Object.keys(typeTwoHourValue).sort(),
      };
    }

    let minuteObject = {};
    if (selectedMinuteRecurrenceType === 0) {
      minuteObject = { selectedMinutes: [] };
    } else if (selectedMinuteRecurrenceType === 1) {
      minuteObject = {
        selectedMinutes: [-1],
      };
    } else if (selectedMinuteRecurrenceType === 2) {
      minuteObject = {
        minutesInterval: typeOneMinuteInterval,
        startMinute: typeOneMinuteStartsAt,
      };
    } else if (selectedMinuteRecurrenceType === 3) {
      minuteObject = {
        selectedMinutes: Object.keys(typeTwoMinuteValue).sort(),
      };
    }

    let daysOfTheMonthObject = {};
    daysOfTheMonthObject = {
      selectedDaysOfTheMonth: Object.keys(typeTwoDayValue).sort(),
    };

    const generatedCronExpression: string = generateCronExpression({
      selectedMonths: selectedMonths,
      selectedDays: Object
        .keys(selectedDaysOfTheWeek)
        .filter((_: string) => selectedDaysOfTheWeek[Number(_)])
        .map((_: string) => Number(_)),
      daysInterval: dailyRecursCount,
      ...daysOfTheMonthObject,
      ...hourObject,
      ...minuteObject,
    });
    
    onSaveCycleTimerDefenitionSettings(generatedCronExpression);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dailyRecursCount, 
    selectedDaysOfTheWeek, 
    selectedHourlyRecurrenceType, 
    selectedMinuteRecurrenceType, 
    selectedMonths, 
    typeOneHourInterval, 
    typeOneHourStartsAt, 
    typeOneMinuteInterval, 
    typeOneMinuteStartsAt, 
    typeTwoDayValue, 
    typeTwoHourValue, 
    typeTwoMinuteValue
  ]);

  useEffect(saveTdsSettings, [saveTdsSettings])

  const handleWeekDaysSelection = (day: number) => {
    setDailyRecursCount(1);
    setSelectedDaysOfTheWeek((_) => ({ ..._, [day]: !_[day] }));
  };

  const RenderWeekDays = () => {

    return (
      <FormGroup>
        {DAYS.map(({ name, value }) => (
          <FormControlLabel
            onClick={() => {
              handleWeekDaysSelection(value);
            }}
            sx={{ textTransform: "capitalize" }}
            control={<Checkbox />}
            label={getTranslation(
              translations,
              `pm.propertyeditor.specificproperties.repetition_details.label_weeks.in_the_days.dayoftheweek.${name}`
            )}
            checked={selectedDaysOfTheWeek[value]}
            key={`days-of-the-week-${name}`}
          />
        ))}
      </FormGroup>
    );
  };

  return (
    <Stack spacing={2} mt={2}>
      <TextField
        select
        fullWidth
        size="small"
        label={getTranslation(
          translations,
          "pm.propertyeditor.specificproperties.type_of_repeat"
        )}
        value={typeOfRepeat}
        onChange={(e) => {
          setTypeOfRepeat(e.target.value);
        }}
      >
        <MenuItem value={"Monthly"}>
          {getTranslation(
            translations,
            "pm.propertyeditor.specificproperties.repetition_details.cycle.label.monthly"
          )}
        </MenuItem>

        <MenuItem value={"Daily"}>
          {getTranslation(
            translations,
            "pm.propertyeditor.specificproperties.repetition_details.cycle.label.daily"
          )}
        </MenuItem>
        <MenuItem value={"Hourly"}>
          {getTranslation(
            translations,
            "pm.propertyeditor.specificproperties.repetition_details.cycle.label.hourly"
          )}
        </MenuItem>
        <MenuItem value={"Minutely"}>
          {getTranslation(
            translations,
            "pm.propertyeditor.specificproperties.repetition_details.cycle.label.minutely"
          )}
        </MenuItem>
      </TextField>

      <Typography textTransform="capitalize" variant="subtitle2">
        {getTranslation(
          translations,
          "pm.propertyeditor.specificproperties.repetition_details"
        )}
      </Typography>
      {typeOfRepeat === "Minutely" && (
        <MinuteRecurrenceGenerator
          selectedMinuteRecurrenceType={selectedMinuteRecurrenceType}
          setSelectedMinuteRecurrenceType={setSelectedMinuteRecurrenceType}
          typeTwoMinuteValue={typeTwoMinuteValue}
          setTypeTwoMinuteValue={setTypeTwoMinuteValue}
        />
      )}
      {typeOfRepeat === "Hourly" && (
        <HourlyRecurrenceGenerator
          selectedHourlyRecurrenceType={selectedHourlyRecurrenceType}
          setSelectedHourlyRecurrenceType={setSelectedHourlyRecurrenceType}
          typeTwoHourValue={typeTwoHourValue}
          setTypeTwoHourValue={setTypeTwoHourValue}
        />
      )}

      {typeOfRepeat === "Daily" && (
        <TextField
          size="small"
          fullWidth
          value={dailyRecursCount}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const value = Number(e.target.value);
            setDailyRecursCount(value < 1 ? 0 : value);
          }}
          label={getTranslation(
            translations,
            "pm.propertyeditor.specificproperties.repetition_details.recurs_every"
          )}
          InputProps={{
            endAdornment: getTranslation(
              translations,
              "pm.propertyeditor.specificproperties.repetition_details.label_days"
            ),
          }}
          type="number"
          disabled={
            !!Object.values(selectedDaysOfTheWeek).filter((_) => _).length
          }
          inputProps={{ min: 0, max: 7 }}
        />
      )}
      {/** note : newly added days in the daily */}
      {typeOfRepeat === "Daily" && <RenderWeekDays />}
      {typeOfRepeat === "Daily" && (
        <DailyRecurrenceGenerator
          typeTwoDayValue={typeTwoDayValue}
          setTypeTwoDayValue={setTypeTwoDayValue}
        />
      )}

      {/** note : recurs every week field */}
      {/** note : days  render */}
      {/** new ly added filters in weekly */}

      {typeOfRepeat === "Monthly" && (
        <TextField
          fullWidth
          label={getTranslation(
            translations,
            "pm.propertyeditor.specificproperties.label.select_months"
          )}
          size="small"
          select
          SelectProps={{
            multiple: true,
            displayEmpty: true,
            renderValue: (selected) =>
              (selected as number[])
                .map((monthNumber: number) => {
                  const monthName = MONTHS.find(
                    month => month.value === monthNumber
                  )?.name;
                  return getTranslation(
                    translations,
                    `pm.propertyeditor.specificproperties.repetition_details.cycle.label.monthly.${monthName}`
                  );
                })
                .join(", "),
          }}
          id="selected-month-field"
          value={selectedMonths}
          onChange={(e) => {
            const value: string | Array<number> = e.target.value;
            if (Array.isArray(value)) {
              if (value[value.length - 1] === -1) {
                setSelectedMonths([-1]);
              } else {
                const allMonthsIndex = value.findIndex(
                  (month: number) => month === -1
                );
                if (allMonthsIndex >= 0) value.splice(allMonthsIndex, 1);
                setSelectedMonths(value);
              }
            }
          }}
        >
          {MONTHS.map((month: { name: string; value: number }) => (
            <MenuItem key={month.value} value={month.value}>
              <Checkbox checked={selectedMonths.indexOf(month.value) > -1} />
              <ListItemText
                sx={{ textTransform: "capitalize" }}
                primary={getTranslation(
                  translations,
                  `pm.propertyeditor.specificproperties.repetition_details.cycle.label.monthly.${month.name}`
                )}
              />
            </MenuItem>
          ))}
        </TextField>
      )}
      {/** as per the client need to be deleted days  */}

      {/* <Button
        sx={{ alignSelf: "end" }}
        variant="contained"
        size="small"
        id="back-button"
        onClick={saveTdsSettings}
      >
        {getTranslation(translations, "pm.button.save")}
      </Button> */}
    </Stack>
  );
};

export default TimerDefinitionSettings;
